/**
 * This definition needs to be updated when new utility classes are added
 */
export interface IWithStylesProps {
  alignItemsCenter?: boolean;
  alignItemsBaseline?: boolean;
  alignItemsFlexStart?: boolean;
  alignSelfCenter?: boolean;
  borderTopLight?: boolean;
  borderBox?: boolean;
  flex?: boolean;
  flexAuto?: boolean;
  flexGrow?: boolean;
  flexShrink?: boolean;
  flexWrap?: boolean;
  flexBasis0?: boolean;
  flexDirectionColumn?: boolean;
  flexDirectionRow?: boolean;
  alignCenter?: boolean;
  alignStart?: boolean;
  justifyCenter?: boolean;
  justifyBetween?: boolean;
  justifyEvenly?: boolean;
  justifyEnd?: boolean;
  margin0?: boolean;
  marginBottomXxl?: boolean;
  marginBottomXl?: boolean;
  marginBottomL?: boolean;
  marginBottomM?: boolean;
  marginBottomS?: boolean;
  marginBottomXs?: boolean;
  marginLeftS?: boolean;
  marginLeftM?: boolean;
  marginLeftL?: boolean;
  marginLeftXl?: boolean;
  marginRightXs?: boolean;
  marginRightS?: boolean;
  marginRightM?: boolean;
  marginRightXl?: boolean;
  marginRightL?: boolean;
  marginTopL?: boolean;
  marginTopXxl?: boolean;
  marginTopXl?: boolean;
  marginTopM?: boolean;
  marginTopS?: boolean;
  padding0?: boolean;
  paddingS?: boolean;
  paddingM?: boolean;
  paddingL?: boolean;
  paddingXl?: boolean;
  paddingVerticalS?: boolean;
  paddingVerticalM?: boolean;
  paddingVerticalL?: boolean;
  paddingHorizontalS?: boolean;
  paddingHorizontalM?: boolean;
  paddingHorizontalL?: boolean;
  paddingBottomS?: boolean;
  paddingBottomM?: boolean;
  paddingBottomL?: boolean;
  paddingBottomXl?: boolean;
  paddingLeftS?: boolean;
  paddingLeftM?: boolean;
  paddingLeftL?: boolean;
  paddingLeftXl?: boolean;
  paddingRightS?: boolean;
  paddingRightM?: boolean;
  paddingRightL?: boolean;
  paddingRightXl?: boolean;
  paddingTopL?: boolean;
  paddingTopXl?: boolean;
  overflowYScroll?: boolean;
  width100?: boolean;
  ["_ut*"]?: boolean;
  textCenter?: boolean;
}

/**
 * Add classes here and update styles/utility-classes.scss
 */
export const UTILITY_CLASSES = [
  "align-items-center",
  "align-items-baseline",
  "align-items-flex-start",
  "align-self-center",
  "border-top-light",
  "border-box",
  "flex",
  "flex-auto",
  "flex-grow",
  "flex-basis-0",
  "flex-shrink",
  "flex-wrap",
  "flex-direction-column",
  "flex-direction-row",
  "align-start",
  "align-center",
  "justify-center",
  "justify-between",
  "justify-evenly",
  "justify-end",
  "margin-0",
  "margin-bottom-xxl",
  "margin-bottom-xl",
  "margin-bottom-l",
  "margin-bottom-m",
  "margin-bottom-xs",
  "margin-bottom-s",
  "margin-left-s",
  "margin-left-m",
  "margin-left-l",
  "margin-left-xl",
  "margin-right-s",
  "margin-right-m",
  "margin-right-xs",
  "margin-right-xl",
  "margin-right-l",
  "margin-top-l",
  "margin-top-m",
  "margin-top-s",
  "margin-top-xl",
  "margin-top-xxl",
  "padding-0",
  "padding-s",
  "padding-m",
  "padding-l",
  "padding-xl",
  "padding-bottom-s",
  "padding-bottom-m",
  "padding-bottom-l",
  "padding-bottom-xl",
  "padding-top-l",
  "padding-top-xl",
  "padding-right-s",
  "padding-right-m",
  "padding-right-l",
  "padding-right-xl",
  "padding-left-s",
  "padding-left-m",
  "padding-left-l",
  "padding-left-xl",
  "padding-bottom-s",
  "padding-vertical-s",
  "padding-vertical-m",
  "padding-vertical-l",
  "padding-horizontal-s",
  "padding-horizontal-m",
  "padding-horizontal-l",
  "overflow-y-scroll",
  "width-100",
  "text-center",
];
